import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Menu, X } from "lucide-react";
import { LOGO_URL, SOCIAL } from "@/data/sponsors";
import { TopBar } from "@/components/TopBar";

const LINKS = [
  { label: "Guida", href: "/donna-impresa" },
  { label: "Manifesto", href: "/manifesto" },
  { label: "Community", href: "/community" },
  { label: "Social", href: "/social" },
  { label: "Le storie", href: "/racconta-la-tua-storia" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="main-navbar" className="fixed inset-x-0 top-0 z-50">
      <TopBar />
      <div
        className={`bg-white/85 backdrop-blur-xl transition-shadow duration-300 ${
          scrolled ? "shadow-[0_8px_32px_rgba(94,42,82,0.09)]" : ""
        }`}
      >
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-3 sm:px-10">
          <Link to="/" className="group flex items-center gap-3" data-testid="navbar-logo">
            <img
              src={LOGO_URL}
              alt="Logo DonnaImpresa"
              className="h-10 w-10 rounded-xl object-cover transition-transform duration-500 group-hover:rotate-6"
            />
            <span className="font-display text-xl tracking-tight text-[#1A1617]">
              Donna<span className="text-[#E0708A]">Impresa</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-7 lg:flex">
            {LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="di-underline text-sm font-medium text-[#6B5E62] hover:text-[#1A1617]"
              >
                {l.label}
              </Link>
            ))}
            <div className="flex items-center gap-3">
              <a
                href={SOCIAL.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="nav-instagram"
                aria-label="Instagram DonnaImpresa"
                className="text-[#5E2A52] transition-transform duration-300 hover:scale-110 hover:text-[#E0708A]"
              >
                <Instagram size={19} />
              </a>
            </div>
            <Link
              to="/racconta-la-tua-storia"
              data-testid="nav-cta-storia"
              className="rounded-full bg-[#E0708A] px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#5E2A52]"
            >
              Racconta la tua storia
            </Link>
          </nav>

          <button
            className="lg:hidden text-[#5E2A52]"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div
            className="border-t border-[#E8E2E4] bg-white px-5 pb-6 pt-3 lg:hidden"
            data-testid="mobile-menu"
          >
            {LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().split(" ")[0]}`}
                className="block py-3 text-base text-[#1A1617]"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/racconta-la-tua-storia"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta-storia"
              className="mt-2 inline-block rounded-full bg-[#E0708A] px-5 py-2.5 text-sm font-semibold text-white"
            >
              Racconta la tua storia
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};
